import { observer } from 'mobx-react-lite'
import { Box } from 'shared/ui'
import { AgentSwitchField } from 'entities/AIAgent/ui/AgentSwitchField/AgentSwitchField'
import { MessageField, type MessageFieldStore } from 'widgets/MessageField'
import type { AutoControlStore } from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/store/autoControlStore'

type IAutoContentActionProps = {
  control: AutoControlStore
  contentStore: MessageFieldStore
  title: string
  questionInfoTooltip: string
}

export const AutoContentAction = observer(
  ({ control, contentStore, title, questionInfoTooltip }: IAutoContentActionProps) => (
    <Box display={'flex'} flexDirection={'column'} gap={2}>
      <div onMouseDown={(e) => e.stopPropagation()}>
        <AgentSwitchField
          title={title}
          active={control.isAuto}
          onChange={control.setIsAuto}
          questionInfoTooltipProps={{ label: questionInfoTooltip, width: 210 }}
        />
      </div>
      {!control.isAuto && <MessageField messageFieldStore={contentStore} />}
    </Box>
  )
)
